import React from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Box, MenuItem, Select, SelectChangeEvent, Tab, Tabs } from "@mui/material";
import SubscriptionHistoryList from "../../features/manageSubscriptions/subscriptionHistoryList";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageSubscriptionDetail = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [type, setType] = React.useState('default');

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Subscription Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subscriptions")}>Subscription & Plan Management</button>
          {' '} - Subscription Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Details" {...a11yProps(0)} />
              <Tab label="Service Providers Subscription History" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="section_title">
            <h2>General Details</h2>
          </div>
          <div className="gap_p">
            <div className="w_33">
              <h6>Plan Name</h6>
              <p>Basic Plan</p>
            </div>
            <div className="w_33">
              <h6>Price</h6>
              <p>$400/Month</p>
            </div>
            <div className="w_33">
              <h6>Created Date</h6>
              <p>01 March 2025</p>
            </div>
          </div>

          <div className="mid_title">
            <h3>Features</h3>
          </div>
          <div className="gap_p">
            <div className="w_33">
              <ul>
                <li>Appear in Top Listings.</li>
                <li>Zero Commission on Bookings.</li>
                <li>Unlimited Service Listings.</li>
                <li>Premium Customer Support.</li>
                <li>Advanced Analytics Dashboard.</li>
                <li>Monthly Promotional Campaigns.</li>
              </ul>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
              </Box>
            </div>
            <div className="right_s form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Status</MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Expired">Expired</MenuItem>
                  <MenuItem value="Canceled">Canceled</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <SubscriptionHistoryList />
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageSubscriptionDetail;
